import {
  FrontendPlugin,
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { rootRouteRef } from './routes';

const oktaGatewayDemoPage = PageBlueprint.make({
  name: 'okta-gateway-demo',
  params: {
    path: '/okta-gateway-demo',
    title: 'Okta Gateway Demo',
    icon: <VpnKeyIcon />,
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/OktaGatewayDemoPage').then(m => (
        <m.OktaGatewayDemoPage />
      )),
  },
});

const oktaGatewayDemoPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'okta-gateway-demo',
  routes: { root: rootRouteRef },
  extensions: [oktaGatewayDemoPage],
});

export default oktaGatewayDemoPlugin;
